import findFeatureByPixel from '../map/findFeatureByPixel';
import Select from 'ol/interaction/Select';
import {MultiLineString, LineString, Point} from 'ol/geom';
import {SINGLECLICK} from 'ol/MapBrowserEventType';


export default function({map, selectStyle, layers, radiusFunc, 
	sectorFunc = false, pie_donut_treshold = 99999999, selectFeature = false, overlay}){ //selectStyle(selectedFeature, selectedPieIndex)

	var popup = overlay;

	var selectedIndex = false;

	var mousePos = [];

	map.on('pointermove', function(evt) {

		if(evt.dragging){
			return false;
		}

		mousePos = evt.pixel;
	});

	var clear = function(){
		selectedIndex = false;

		var interactionFeatures = selectInteraction.getFeatures();
		interactionFeatures.clear();
		if(interactionFeatures.getArray().length > 0) {
			selectFeature(false);
		}
	}

	var prevZoom = map.getView().getZoom();
	map.on('moveend', (evt) => {
		
		if(evt.dragging) {
			return false;
		}

		var zoom = map.getView().getZoom();

	  	if(typeof prevZoom !== 'undefined' && prevZoom !== zoom) {

			clear();
			prevZoom = zoom;
		}
	
	});

// Control Select 
	
	var selectInteraction = new Select({
        style: (f, resolution) => {

        	return selectStyle(f, resolution, selectedIndex);
        },
        filter: function(feature, layer) {

        	return true;//layer.getProperties().group === 'schools';
        },
        condition: function(event) {

        	return false;

        	if(event.dragging){
        		return;
        	}

        	if(event.type !== SINGLECLICK 
        	//	&& event.type !== ol.MapBrowserEventType.POINTERMOVE
        		){



        		return false;
        	}

        	selectInteraction.getFeatures().clear();

        	return true;
        }
    });

//	mapState.set('popup', popup);
//	mapState.set('selectInteraction', selectInteraction);

	//custom implementation feature selection
	var interactionEvent = function(event) {

		if(event.dragging){
    		return;
    	}

		var feature = findFeatureByPixel({
			map, 
			pixel: event.pixel, 
			layers, 
			radiusFunc
		});

		if(!feature) {

			var interactionFeatures = selectInteraction.getFeatures();

			selectedIndex = false;

			if(interactionFeatures.getArray().length > 0) {
				selectFeature(false);
			}
			
			interactionFeatures.clear();
			return;
		}
		

		if(feature.getGeometry() instanceof Point) {
			var coords = feature.getGeometry().getCoordinates();

		} else if (feature.getGeometry() instanceof LineString) {
			var coordsStart = feature.getGeometry().getCoordinateAt(0);
			var coordsEnd = feature.getGeometry().getCoordinateAt(0);

			if(coordsEnd[1] > coordsStart[1]) {

				var coords = coordsEnd;
			} else {
				
				var coords = coordsStart;
			}
		} else if (feature.getGeometry() instanceof MultiLineString) {
			var coords = feature.getGeometry().getLineString(0).getCoordinateAt(0);

		}

		var featurePixed = map.getPixelFromCoordinate(coords);

		if(!sectorFunc) {

			var interactionFeatures = selectInteraction.getFeatures();
			interactionFeatures.clear();

			if(feature) {
				selectFeature(feature);
				interactionFeatures.push(feature);
			}

			popup.setPositioning('top-right');
			var coords = map.getCoordinateFromPixel(featurePixed);
			popup.setPosition(coords);

			return feature;
		}

		//find sector
		var sectors = sectorFunc(feature);
		var intRadius = radiusFunc(feature);

		var x = mousePos[0] - featurePixed[0];
		var y = featurePixed[1] - mousePos[1];

		var angle = Math.atan2(x, y) * (180 / Math.PI);
		if(angle < 0) angle += 360;


		var a0 = 0;
		var sum = 0;
		for (var i = sectors.length - 1; i >= 0; i--) {
			sum += sectors[i];

		}

		var selectedSectorIndex = false;
		var selectOverlayAngle = 0;



		for (var i = 0, len = sectors.length; i < len; i++) {

			var a = a0 + sectors[i]/sum * 360;

			if(angle < a && angle > a0) {

				selectedSectorIndex = i;

				selectOverlayAngle = a0 + (sectors[i]/sum * 360) / 2;

				//WIP: move to interaction
			//	if(!pieChartState.getSelectIndex()){
			//	pieChartState.setSectorData(pdata.valueArray[i]);
			//	pieChartState.selectIndex(selectedSectorIndex);
			//	} 
				
			}

			a0 = a;
		}

		selectedIndex = selectedSectorIndex;

		var pixeldistanceX = Math.cos((selectOverlayAngle-90) / 180 * Math.PI) * intRadius * 1.1;
		var pixeldistanceY = Math.sin((selectOverlayAngle-90) / 180 * Math.PI) * intRadius * 1.1;
		
		if(selectOverlayAngle >= 0 && selectOverlayAngle <= 90){
			popup.setPositioning('bottom-center');

		} else if(selectOverlayAngle > 90 && selectOverlayAngle <= 180){
			popup.setPositioning('top-left');

		} else if(selectOverlayAngle > 180 && selectOverlayAngle < 270) {
			popup.setPositioning('top-right');

		} else {
			popup.setPositioning('bottom-right');
		}

		if(feature){
			var interactionFeatures = selectInteraction.getFeatures();
			interactionFeatures.clear();
			selectFeature(feature, selectedSectorIndex);
			interactionFeatures.push(feature);
		}

		var popupPixel = [featurePixed[0] + pixeldistanceX, featurePixed[1] + pixeldistanceY];
		var coords = map.getCoordinateFromPixel(popupPixel);
		popup.setPosition(coords);

		///

		
		
	}
	map.on('click', interactionEvent);

	selectInteraction.getFeatures().on(['add','remove'], function(e) {

		if(selectInteraction.getFeatures().getArray().length == 0){
    		popup.setPosition(undefined);
    	//	StudentsState.setActiveSchool(null);
    		
    	} else {

    	//	selectFeature({feature: selectInteraction.getFeatures().getArray()[0], mousePos: mousePos, map: map});
    	}

	});

	map.addOverlay(popup);
	map.addInteraction(selectInteraction);

	selectInteraction.disable = function(){
		map.un('click', interactionEvent);
	}

	selectInteraction.clear = clear;

	return selectInteraction //{selectInteraction, popup};
}




// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapData/interaction.js